"use client";
import { useEffect, useState, useRef } from "react";
import {
  productRecentView,
} from "@/service/index/index";
import { ProductCard } from "@/app/components/common/ProductCard";
import { ProductItemCard } from "@/app/components/common/ProductItemCard";
import { handleImgUrl } from "@/utils/tools";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import useMobileDetect from "@/hooks/useMobileDetect";
import type { Swiper as SwiperType } from 'swiper'; // 导入 Swiper 类型

import "swiper/css";
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

type ProductProps = {
  defaultItemUrl: string;
  name: string;
  pic: string[];
  rating: string | null;
  reviewCount: string | null;
  itemId: string;
  spuId: string;
  spuCode: string
  price: number
  originPrice: number
  category?: string,
  productItems: any[],
  salePrice: number,
  newProduct?:boolean
};

type RecentlyViewtdProps = {
  isFirstMobile?: boolean,
  type?: number,
  cardAmountOnLine?: number
}
export const RecentlyViewtd: React.FC<RecentlyViewtdProps> = ({ isFirstMobile, type, cardAmountOnLine }) => {

  const [historyList, setHistoryList] = useState<ProductProps[]>([]);
  const isMobile = useMobileDetect(isFirstMobile);
  const lineSpuCount = isMobile ? 2 : 7
  const swiperRef = useRef<SwiperType | null>(null);
  const [allowSlidePrev, setAllowSlidePrev] = useState(false);
  const [allowSlideNext, setAllowSlideNext] = useState(false);

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const data = await productRecentView({});
    setHistoryList(data.data);
    //
    if (data.data.length) {
      setTimeout(() => {
        bindGtag()
        setAllowSlideNext(swiperRef.current?.allowSlideNext || false)
      }, 100)
    }
  }

  const bindGtag = () => {
    const productCardsContents = window.document.querySelectorAll("#recentlyViewed .cardItemContent")
    const options = {
      root: null,
      threshold: 1
    }

    // 创建一个 IntersectionObserver 实例
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio === 1) {
          // 商品卡片进入可视区域，触发埋点
          trackProductExposure(entry.target as HTMLElement);
          // 停止观察该元素，避免重复记录曝光
          observer.unobserve(entry.target);
        }
      });
    }, options);

    // 开始观察每个商品内容
    productCardsContents.forEach(cardContent => {
      // observer.unobserve(cardContent);
      observer.observe(cardContent);
    });
  }

  // 埋点函数
  const trackProductExposure = (card: HTMLElement) => {

    const userInfoStr = globalThis?.localStorage?.getItem("userInfo")
    const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}

    const { contentPosition, contentId, contentName } = card.dataset;
    const cardItemDom = card.closest('.cardItem') as HTMLElement

    if (cardItemDom && cardItemDom?.dataset) {
      const { cardType, cardIdx } = cardItemDom.dataset
      // 触发 content_impression 事件
      // @ts-ignore
      window.gtag('event', 'content_impression', {
        user_id: userInfo?.id,
        content_id: (cardType || '') + cardIdx + '-' + contentId,
        content_name: contentName,
        content_position: contentPosition,
        exposure_time: Date.now(),
      });
    }
  }

  return historyList?.length > 0 ?
    <>
      <div
        className="mx-20 mb-8 md:mb-24 md:mx-40 flex justify-between items-center"
        style={{ fontSize: isMobile ? "2.2rem" : "2.4rem" }}
      >
        {
          type === 2 ?
          <h2 className="font-medium text-lg text-bravve-100">Recently Viewed</h2> 
          :
          <h2 style={{ fontSize: isMobile ? "2.2rem" : "2.8rem" }} className="font-bold text-bravve-100">Recently Viewed</h2> 
        }
        
        {/* {
          isMobile ?
          null
          :
          <div className="flex justify-between items-center gap-x-16 relative">
            <div className={"flex justify-between items-center"}>
              <iconpark-icon name="left" color="#402C22" size="24"
                class={(allowSlidePrev ? '' : 'opacity-30') + " cursor-pointer"}
                icon-id='left' onClick={() => { swiperRef.current?.slidePrev() }} />
              <iconpark-icon name="right" color="#402C22" size="24"
                class={(allowSlideNext ? '' : 'opacity-30') + " cursor-pointer"}
                icon-id='right' onClick={() => { swiperRef.current?.slideNext() }}
              />
            </div>
          </div>
        } */}
        <div className="flex justify-between items-center gap-x-16 relative">
          <div className={"flex justify-between items-center"}>
            <iconpark-icon name="left" color="#402C22" size="24"
              class={(allowSlidePrev ? '' : 'opacity-30') + " cursor-pointer"}
              icon-id='left' onClick={() => { swiperRef.current?.slidePrev() }} />
            <iconpark-icon name="right" color="#402C22" size="24"
              class={(allowSlideNext ? '' : 'opacity-30') + " cursor-pointer"}
              icon-id='right' onClick={() => { swiperRef.current?.slideNext() }}
            />
          </div>
        </div>
      </div>

      <div className="mx-12 md:mx-32" id='recentlyViewed'>
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper; // 存储 Swiper 实例
          }}
          onSlideChange={(swiper: SwiperType) => {
            // console.log('活动幻灯片已更改，当前索引:', swiper.activeIndex);
            if (swiperRef.current?.isEnd !== undefined) {
              setAllowSlideNext(!swiperRef.current?.isEnd)
            }
            if (swiperRef.current?.isBeginning !== undefined) {
              setAllowSlidePrev(!swiperRef.current?.isBeginning)
            }
          }}
          className={`ProductListCarousel item-w-${lineSpuCount}`}
          modules={[Navigation]}
          slidesPerView={lineSpuCount}
          slidesPerGroup={lineSpuCount}
          navigation={true}
        >
          {historyList.map((item: ProductProps, idx: number) => {
            return (
              <SwiperSlide key={idx}>
                {/* <ProductCard
                  idx={idx}
                  linkUrl={item.defaultItemUrl}
                  key={item.spuId}
                  category={item.category}
                  spuCode={item.spuCode}
                  product={item.name}
                  img={item.pic.map(item => handleImgUrl(item, '616x616'))}
                  container="w-full cardItemContent"
                  currentPrice={999}
                  type={2}
                /> */}
                <ProductItemCard 
                  idx={idx}
                  spuId={item.spuId}
                  spuCode={item.spuCode}
                  category={item.category}
                  // productItems={item.productItems}
                  key={item.spuId}
                  linkUrl={item.defaultItemUrl}
                  img={item.pic.map(item => handleImgUrl(item, '616x616'))}
                  product={item.name}
                  container="w-full cardItemContent"
                  // currentPrice={item.salePrice}
                  type={2}
                  newProduct={item?.newProduct}
                />
              </SwiperSlide>
            );
          }
          )}
        </Swiper>
      </div>
    </>
    :
    null
}